import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-test-alert',
  templateUrl: './tutorial-test-alert.component.html',
  styleUrls: ['./tutorial-test-alert.component.css']
})
export class TutorialTestAlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
